<template>
  <v-date-picker
    no-title
    v-model="date"
    :type="type"
    :color="color"
    :min="min"
    :max="max"
    :range="range"
  />
</template>

<script>
export default {
  data: () => ({
    date: undefined,
  }),
  props: {
    initialDate: [String, Array],
    type: {
      type: String,
      default: "daily",
    },
    max: {
      type: [String, Object],
      default: new Date().toISOString(),
    },
    min: {
      type: [String, Object],
      default: undefined,
    },
    color: {
      type: String,
      default: "green lighten-1",
    },
    range: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    date: {
      handler() {
        this.$emit("input", this.date);
      },
      immediate: true,
      deep: true,
    },
    initialDate: {
      handler() {
        this.date = this.initialDate;
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style></style>
